/**
 * @class
 * @function ProductRecommendations
 */

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('.product-recommendations--parent');
      this.isLoading = false;
    }

    async fetchProducts() {
      if (this.isLoading || !this.dataset.url) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await fetch(this.dataset.url, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(
            `Recommendations request failed: ${response.status}`
          );
        }

        const htmlText = await response.text();
        const html = document.createElement('div');
        html.innerHTML = htmlText;

        const recommendations = html.querySelector(
          'product-recommendations'
        );

        if (!recommendations) {
          console.warn(
            'Product recommendations element was not found in the response.',
            this.dataset.url
          );
          this.classList.add('product-recommendations--loaded');
          return;
        }

        const content = recommendations.innerHTML.trim();

        if (!content) {
          console.warn(
            'Shopify returned an empty recommendations section.',
            this.dataset.url
          );
          this.classList.add('product-recommendations--loaded');
          return;
        }

        this.innerHTML = content;

        const productCards = this.querySelectorAll(
          '.product-card, .product-grid-item, .product'
        );

        console.log(
          'Recommendations loaded.',
          'Product cards detected:',
          productCards.length,
          'URL:',
          this.dataset.url
        );

        if (this.parent) {
          this.parent.classList.add(
            'product-recommendations--full'
          );

          if (document.body.classList.contains('open-cart')) {
            this.parent.classList.add('active');
          }
        }

        this.classList.add('product-recommendations--loaded');

        this.dispatchEvent(
          new CustomEvent('recommendations:loaded', {
            bubbles: true
          })
        );

      } catch (error) {
        console.error(
          'Unable to load product recommendations:',
          error
        );

        this.classList.add('product-recommendations--loaded');
      } finally {
        this.isLoading = false;
      }
    }

    connectedCallback() {
      this.fetchProducts();
    }
  }

  customElements.define(
    'product-recommendations',
    ProductRecommendations
  );
}